/**
 * premium-config.js - Configuration centralisée du mode premium
 * Modifier les valeurs ci-dessous pour personnaliser l'expérience
 */

(function() {
  'use strict';
  
  // ===============================================
  // CONFIGURATION PRINCIPALE
  // ===============================================
  
  window.PREMIUM_CONFIG = {
    
    // ========== MODE PREMIUM ==========
    // Activer/désactiver toutes les fonctionnalités premium
    enabled: true,
    
    // ========== PERFORMANCE ==========
    // Mode de performance : 'auto' | 'high' | 'low'
    // - 'auto' : Détection automatique et adaptation (EXPERIMENTAL - désactivé par défaut)
    // - 'high' : Force tous les effets (RECOMMANDÉ)
    // - 'low' : Désactive les effets coûteux
    perfMode: 'high',
    
    // Activer le Performance Monitor (mode auto seulement)
    // ⚠️ EXPERIMENTAL - Peut causer des switches intempestifs
    enablePerfMonitor: false,
    
    // Seuil FPS pour basculer en low-perf (mode auto uniquement)
    fpsTreshold: 45,
    
    // Durée de vérification avant switch (ms)
    perfCheckDuration: 2000,
    
    // ========== AUDIO ==========
    audio: {
      enabled: true,
      volume: 0.3,              // Volume global (0-1)
      pitchVariation: 0.03,     // Variation de pitch (0-0.1)
      useFallback: false        // Force l'utilisation de sons synthétiques
    },
    
    // ========== ANIMATIONS ==========
    animations: {
      // Durées (ms)
      instant: 80,
      fast: 180,
      normal: 260,
      slow: 420,
      
      // Activer/désactiver par type
      cardDraw: true,
      cardPlay: true,
      cardFlip: true,
      particles: true,
      
      // Nombre de particules
      sparkleCount: 3,
      scoreSparkleCount: 5
    },
    
    // ========== PIXI POSTFX ==========
    postfx: {
      enabled: true,
      
      bloom: {
        enabled: true,
        strength: 0.15,    // 0-1 (0.15 = très subtil)
        blur: 2,           // 0-10
        quality: 4         // 1-10
      },
      
      vignette: {
        enabled: true,
        strength: 0.3,     // 0-1
        radius: 0.8        // 0-1
      }
    },
    
    // ========== MICRO-INTERACTIONS ==========
    interactions: {
      // Boutons
      buttonHoverLift: 2,        // px
      buttonHoverScale: 1.02,    // 1-1.1
      buttonPressScale: 0.98,    // 0.9-1
      
      // Cartes
      cardHoverScale: 1.03,      // 1-1.1
      cardTilt3D: true,          // Desktop uniquement
      cardPressScale: 0.96       // Mobile uniquement
    },
    
    // ========== PRELOADER ==========
    preloader: {
      enabled: true,
      showProgress: true,
      
      // Nombre de cartes à précharger
      priorityCards: 10,
      
      // Délai minimum avant de cacher le loader (ms)
      minDisplayTime: 500
    },
    
    // ========== MOBILE OPTIMIZATIONS ==========
    mobile: {
      disableZoom: true,
      disablePullToRefresh: true,
      disableTextSelection: true,
      disableTilt3DOnLowEnd: true,
      
      // Détection d'appareil faible
      lowEndThreshold: {
        cores: 4,              // CPU cores
        androidVersion: 6      // Version Android minimale
      }
    },
    
    // ========== EFFECTS INTENSITY ==========
    // Multiplicateurs globaux (0-1)
    intensity: {
      shadows: 1.0,
      blur: 1.0,
      glow: 1.0,
      particles: 1.0
    },
    
    // ========== DEBUG ==========
    debug: {
      enabled: false,
      logAudio: false,
      logAnimations: false,
      logPerformance: true,
      showFPS: false
    }
  };
  
  // ===============================================
  // APPLICATION DE LA CONFIG
  // ===============================================
  
  // Appliquer les valeurs globales
  window.PREMIUM_MODE = window.PREMIUM_CONFIG.enabled;
  window.PERF_MODE = window.PREMIUM_CONFIG.perfMode;
  
  // Exposer une fonction pour recharger la config
  window.reloadPremiumConfig = function() {
    console.log('[Config] Reloading premium configuration...');
    
    // Appliquer mode premium
    if (window.PREMIUM_CONFIG.enabled) {
      document.body.classList.add('premium-mode');
    } else {
      document.body.classList.remove('premium-mode');
    }
    
    // Appliquer mode perf
    if (window.PREMIUM_CONFIG.perfMode === 'low') {
      document.body.classList.add('low-perf');
    } else {
      document.body.classList.remove('low-perf');
    }
    
    // Appliquer config audio
    if (window.audioManager) {
      window.audioManager.setEnabled(window.PREMIUM_CONFIG.audio.enabled);
      window.audioManager.setVolume(window.PREMIUM_CONFIG.audio.volume);
    }
    
    // Appliquer config PostFX
    if (window.__pixiPostFX) {
      if (window.PREMIUM_CONFIG.postfx.enabled) {
        window.__pixiPostFX.enable();
        
        if (window.PREMIUM_CONFIG.postfx.bloom.enabled) {
          window.__pixiPostFX.setBloomStrength(window.PREMIUM_CONFIG.postfx.bloom.strength);
        }
        
        if (window.PREMIUM_CONFIG.postfx.vignette.enabled) {
          window.__pixiPostFX.setVignetteStrength(window.PREMIUM_CONFIG.postfx.vignette.strength);
        }
      } else {
        window.__pixiPostFX.disable();
      }
    }
    
    console.log('[Config] Configuration reloaded');
  };
  
  // ===============================================
  // PRESETS RAPIDES
  // ===============================================
  
  window.PREMIUM_PRESETS = {
    
    // Preset : Performance maximale (tous les effets)
    ultra: function() {
      window.PREMIUM_CONFIG.perfMode = 'high';
      window.PREMIUM_CONFIG.postfx.bloom.strength = 0.2;
      window.PREMIUM_CONFIG.postfx.vignette.strength = 0.4;
      window.PREMIUM_CONFIG.animations.sparkleCount = 5;
      window.PREMIUM_CONFIG.animations.scoreSparkleCount = 8;
      window.PREMIUM_CONFIG.intensity.shadows = 1.0;
      window.PREMIUM_CONFIG.intensity.blur = 1.0;
      window.PREMIUM_CONFIG.intensity.glow = 1.0;
      window.PREMIUM_CONFIG.intensity.particles = 1.0;
      window.reloadPremiumConfig();
      console.log('[Preset] Ultra mode activated');
    },
    
    // Preset : Équilibre qualité/performance (recommandé)
    balanced: function() {
      window.PREMIUM_CONFIG.perfMode = 'auto';
      window.PREMIUM_CONFIG.postfx.bloom.strength = 0.15;
      window.PREMIUM_CONFIG.postfx.vignette.strength = 0.3;
      window.PREMIUM_CONFIG.animations.sparkleCount = 3;
      window.PREMIUM_CONFIG.animations.scoreSparkleCount = 5;
      window.PREMIUM_CONFIG.intensity.shadows = 0.8;
      window.PREMIUM_CONFIG.intensity.blur = 0.8;
      window.PREMIUM_CONFIG.intensity.glow = 0.8;
      window.PREMIUM_CONFIG.intensity.particles = 0.8;
      window.reloadPremiumConfig();
      console.log('[Preset] Balanced mode activated');
    },
    
    // Preset : Performance (désactive effets coûteux)
    performance: function() {
      window.PREMIUM_CONFIG.perfMode = 'low';
      window.PREMIUM_CONFIG.postfx.enabled = false;
      window.PREMIUM_CONFIG.animations.particles = false;
      window.PREMIUM_CONFIG.animations.sparkleCount = 0;
      window.PREMIUM_CONFIG.animations.scoreSparkleCount = 0;
      window.PREMIUM_CONFIG.intensity.shadows = 0.3;
      window.PREMIUM_CONFIG.intensity.blur = 0;
      window.PREMIUM_CONFIG.intensity.glow = 0.3;
      window.PREMIUM_CONFIG.intensity.particles = 0;
      window.reloadPremiumConfig();
      console.log('[Preset] Performance mode activated');
    },
    
    // Preset : Minimal (seulement micro-interactions basiques)
    minimal: function() {
      window.PREMIUM_CONFIG.enabled = false;
      window.PREMIUM_CONFIG.audio.enabled = false;
      window.PREMIUM_CONFIG.postfx.enabled = false;
      window.PREMIUM_CONFIG.animations.particles = false;
      window.reloadPremiumConfig();
      console.log('[Preset] Minimal mode activated');
    },
    
    // Preset : Experimental (active le Performance Monitor)
    experimental: function() {
      window.PREMIUM_CONFIG.perfMode = 'auto';
      window.PREMIUM_CONFIG.enablePerfMonitor = true;
      window.reloadPremiumConfig();
      console.log('[Preset] Experimental mode activated (Performance Monitor enabled)');
      console.warn('[Preset] This may cause instability - use at your own risk');
    }
  };
  
  // ===============================================
  // HELPERS DE DEBUG
  // ===============================================
  
  window.premiumDebug = {
    
    // Afficher la config actuelle
    showConfig: function() {
      console.table(window.PREMIUM_CONFIG);
    },
    
    // Tester tous les sons
    testAllSounds: function() {
      const sounds = ['tap', 'whoosh', 'flip', 'sparkle', 'score', 'win', 'draw', 'play'];
      let i = 0;
      
      const playNext = () => {
        if (i < sounds.length) {
          console.log(`[Test] Playing: ${sounds[i]}`);
          window.playSound(sounds[i]);
          i++;
          setTimeout(playNext, 800);
        } else {
          console.log('[Test] All sounds tested');
        }
      };
      
      playNext();
    },
    
    // Tester toutes les animations
    testAllAnimations: function() {
      const animations = ['draw', 'play', 'flip'];
      const testElement = document.querySelector('.card-item');
      
      if (!testElement) {
        console.warn('[Test] No card element found');
        return;
      }
      
      let i = 0;
      const animateNext = () => {
        if (i < animations.length) {
          console.log(`[Test] Animation: ${animations[i]}`);
          window.animateCard(testElement, animations[i]);
          i++;
          setTimeout(animateNext, 1000);
        } else {
          console.log('[Test] All animations tested');
        }
      };
      
      animateNext();
    },
    
    // Afficher les stats de performance
    showPerf: function() {
      if (window.premiumUI && window.premiumUI.perfMonitor) {
        const fps = window.premiumUI.perfMonitor.getAverageFPS();
        const mode = window.premiumUI.perfMonitor.currentMode;
        console.log(`[Perf] Average FPS: ${fps} | Mode: ${mode}`);
      } else {
        console.warn('[Perf] Monitor not available');
      }
    }
  };
  
  console.log('[Config] Premium configuration loaded');
  console.log('[Config] Use window.PREMIUM_PRESETS.balanced() to change preset');
  console.log('[Config] Use window.premiumDebug.showConfig() to see current config');
  
})();
